<app-form (submit)="updateInfo()">
    <div class="card">
        <div class="card-header">
            <h3 class="card-header-title">{{ isNew ? 'New API key' : 'Edit API key' }}</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <app-form-field label="Description">
                        <input required [(ngModel)]="data.description"
                               type="text" class="form-control"
                               placeholder="Enter a suitable name for this API key, e.g. Github">
                    </app-form-field>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-flex justify-content-between">
                <a class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                <button type="submit" class="btn btn-primary">{{ isNew ? 'Create API key' : 'Save changes' }}</button>
            </div>
        </div>
    </div>
</app-form>